import Container from "./container";
import React from "react";
import { cn } from "../lib/helpers";
import { Link } from "gatsby";

import * as styles from "../styles/components/page-header.module.css";

const PageHeader = (props) => {
  const {
    title,
    description,
    button,
    category
  } = props;

  return (
    <div className={styles.root}>
      <Container>
        <div className="content-xxl">
          <div className={cn("h6", styles.subtitle)}>{category} Solution</div>
          {title && <h1 className={cn("h2", styles.title)}>{title}</h1>}
        </div>
        {(description || (button && button.url)) &&
          <div className="content-lg">
            {description && <p>{description}</p>}
            {button && button.url && 
              <>
              {button.blank
                ? <a href={button.url} className={cn("btn", button.secondaryButton && "secondary")} target="_blank" rel="noreferrer">
                    {button.text}
                  </a>
                : <Link to={button.url} className={cn("btn", button.secondaryButton && "secondary")}>
                    {button.text}
                  </Link>
              }
              </>
            }
          </div>
        }
      </Container>
    </div>
  );
}

export default PageHeader;
